module.exports = __webpack_public_path__ + "img/Avatar.3b4c2295.svg";